const Wishlist = (() => {
  const STORAGE_KEY = 'shopify_wishlist';

  function getAll() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch { return []; }
  }

  function save(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items } }));
  }

  function add(product) {
    const items = getAll();
    if (!items.find(i => i.id === product.id)) { items.push(product); save(items); }
  }

  function remove(productId) {
    save(getAll().filter(i => i.id !== productId));
  }

  function toggle(product) {
    if (has(product.id)) { remove(product.id); return false; }
    else { add(product); return true; }
  }

  function has(productId) { return getAll().some(i => i.id === productId); }
  function count() { return getAll().length; }

  return { getAll, add, remove, toggle, has, count };
})();

// ── Nav Icon State ────────────────────────────────────────
function updateNavIcon() {}

// ── Delegated click — one listener on document, no per-button binding ──
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-wishlist-btn]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const productId = parseInt(btn.dataset.productId, 10);
  const productData = {
    id:     productId,
    title:  btn.dataset.productTitle,
    price:  btn.dataset.productPrice,
    image:  btn.dataset.productImage,
    url:    btn.dataset.productUrl,
    vendor: btn.dataset.productVendor || '',
  };

  const added = Wishlist.toggle(productData);
  updateBtnState(btn, added);
  showToast(added ? 'Added to Wishlist' : 'Removed from Wishlist', added);
}, true);


// ── Button state — only paints heart, never binds events ──
function initWishlistButtons() {
  document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
    updateBtnState(btn, Wishlist.has(parseInt(btn.dataset.productId, 10)));
  });
}

function updateBtnState(btn, isWishlisted) {
  btn.classList.toggle('is-wishlisted', isWishlisted);
  btn.setAttribute('aria-label', isWishlisted ? 'Remove from wishlist' : 'Add to wishlist');
  btn.setAttribute('aria-pressed', isWishlisted);
}


// ── Toast ─────────────────────────────────────────────────
function showToast(message, added) {
  let toast = document.getElementById('wishlist-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'wishlist-toast';
    document.body.appendChild(toast);
  }

  toast.innerHTML = `
    <span class="wishlist-toast__icon">${added ? '♥' : '♡'}</span>
    <span>${message}</span>
    <a href="/pages/wishlist?view=wishlist" class="wishlist-toast__link">View Wishlist →</a>
  `;
  toast.classList.remove('is-visible');
  void toast.offsetWidth;
  toast.classList.add('is-visible');

  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => toast.classList.remove('is-visible'), 3000);
}


// ── Wishlist Page ─────────────────────────────────────────
function renderWishlistPage() {
  const container = document.getElementById('wishlist-page-items');
  if (!container) return;

  const items   = Wishlist.getAll();
  const emptyEl = document.getElementById('wishlist-empty');
  const countEl = document.getElementById('wishlist-item-count');

  if (countEl) countEl.textContent = `${items.length} Item${items.length !== 1 ? 's' : ''}`;

  if (items.length === 0) {
    container.innerHTML = '';
    if (emptyEl) emptyEl.style.display = 'block';
    return;
  }

  if (emptyEl) emptyEl.style.display = 'none';

  container.innerHTML = items.map(item => `
    <div class="wishlist-item" data-id="${item.id}">
      <div class="wishlist-item__image-wrap">
        <a href="${item.url}">
          <img src="${item.image || ''}" alt="${item.title}" class="wishlist-item__image" loading="lazy">
        </a>
        <button class="wishlist-item__remove" data-remove-id="${item.id}" aria-label="Remove from wishlist" type="button">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
      <div class="wishlist-item__info">
        <div class="wishlist-item__meta">
          <a href="${item.url}" class="wishlist-item__title">${item.title}</a>
          <p class="wishlist-item__price">${item.price}</p>
        </div>
      </div>
    </div>
  `).join('');

  container.querySelectorAll('[data-remove-id]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      const id   = parseInt(btn.dataset.removeId, 10);
      const card = btn.closest('.wishlist-item');
      if (card) {
        card.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
        card.style.opacity    = '0';
        card.style.transform  = 'scale(0.95)';
        setTimeout(() => { Wishlist.remove(id); renderWishlistPage(); }, 240);
      } else {
        Wishlist.remove(id); renderWishlistPage();
      }
    });
  });
}


// ── MutationObserver — paints hearts on cards Dawn adds after load ──
function observeCards() {
  new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        const btns = node.matches('[data-wishlist-btn]')
          ? [node]
          : [...node.querySelectorAll('[data-wishlist-btn]')];
        btns.forEach(btn => {
          updateBtnState(btn, Wishlist.has(parseInt(btn.dataset.productId, 10)));
        });
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}


// ── Init ──────────────────────────────────────────────────
function initAll() {
  initWishlistButtons();
  observeCards();
  renderWishlistPage();
  updateNavIcon();
}

document.addEventListener('DOMContentLoaded', initAll);

window.addEventListener('wishlist:updated', () => {
  document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
    updateBtnState(btn, Wishlist.has(parseInt(btn.dataset.productId, 10)));
  });
  updateNavIcon();
});

window.addEventListener('storage', e => {
  if (e.key === 'shopify_wishlist') {
    renderWishlistPage();
    updateNavIcon();
  }
});